import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    stickyAnchor: String,
    transparent: Boolean,
    theme: String
  }

  static targets = ['signupLink', 'loginLink']

  connect() {
    // Cache DOM elements
    this.anchorElement = this.stickyAnchorValue ? document.querySelector(this.stickyAnchorValue) : null

    // Initial measurements
    this.updateMeasurements()

    // Listen for resize
    this.boundUpdateMeasurements = this.updateMeasurements.bind(this)
    window.addEventListener('resize', this.boundUpdateMeasurements)

    // Watch for DOM changes
    this.observer = new MutationObserver(this.boundUpdateMeasurements)
    if (this.anchorElement) {
      this.observer.observe(this.anchorElement, {
        attributes: true,
        childList: true,
        subtree: true
      })
    }
  }

  disconnect() {
    window.removeEventListener('resize', this.boundUpdateMeasurements)
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  onScroll() {
    this.toggleSticky()
    this.toggleLinkColors()
  }

  toggleSticky() {
    if (this.shouldStick === this.hasStickyClass) return

    const logoDefault = this.element.querySelector('.logo-default')
    const logoSticky = this.element.querySelector('.logo-sticky')

    if (this.shouldStick) {
      if (this.transparentValue) {
        this.element.classList.remove('navbar-transparent')
        this.element.classList.add('sticky', 'top-0', 'navbar-shadow', 'navbar-primary', '-mb-16')
      } else {
        this.element.classList.add('sticky', 'top-0', 'navbar-shadow', 'navbar-primary')
      }

      if (logoDefault) logoDefault.classList.add('hidden')
      if (logoSticky) logoSticky.classList.remove('hidden')
    } else {
      if (this.transparentValue) this.element.classList.add('navbar-transparent')
      this.element.classList.remove('sticky', 'top-0', 'navbar-shadow', 'navbar-primary', '-mb-16')

      if (logoDefault) logoDefault.classList.remove('hidden')
      if (logoSticky) logoSticky.classList.add('hidden')
    }
  }

  toggleLinkColors() {
    const colorClass = this.themeValue !== 'light' ? 'text-dark' : this.shouldStick ? 'text-dark' : 'text-white'
    this.signupLinkTarget.classList.remove('text-dark', 'text-white')
    this.signupLinkTarget.classList.add(colorClass)
    this.loginLinkTarget.classList.remove('text-dark', 'text-white')
    this.loginLinkTarget.classList.add(colorClass)
  }

  updateMeasurements() {
    this.elementHeight = this.element.clientHeight
    this.anchorHeight = this.anchorElement ? this.anchorElement.clientHeight : 0
    this.stickyThreshold = this.anchorElement ? this.anchorHeight - this.elementHeight : 3
  }

  get shouldStick() {
    return window.scrollY >= this.stickyThreshold
  }

  get hasStickyClass() {
    return this.element.classList.contains('sticky')
  }
}
